import { IsRootPathSegment } from './segment';
import { PathSegmentsPush } from './mutate';
export function NormalizePathSegments(path, options) {
    const length = path.length;
    if (length === 0) {
        return ['.'];
    }
    else {
        const normalized = [];
        const firstSegment = path[0];
        let i = 0;
        if (IsRootPathSegment(firstSegment, options.rootRegExp)) {
            normalized.push(firstSegment);
            i++;
        }
        else {
            normalized.push('.');
        }
        for (; i < length; i++) {
            if (path[i] !== '') {
                PathSegmentsPush(normalized, path[i], options);
            }
        }
        return normalized;
    }
}
//# sourceMappingURL=normalize.js.map